export const values = (type) => Object.keys(type).map(x => type[x])
